<template>
  <v-app id="inspire">
    <v-content>
      <v-container
        class="fill-height teal darken-3"
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="4"
          >
            <v-card class="elevation-12">
              <v-toolbar
                class="teal darken-4 white--text"
                dark
                flat
              >
                <v-toolbar-title><span class="title ml-3 mr-5">Semanggi&nbsp;<span class="font-weight-light">POS</span></span></v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-form @submit="validate" ref="form" v-model="valid" lazy-validation v-bind:style="{width:'325px'}">
                  <v-text-field
                    v-model="email" 
                    label="E-mail / Username / Phone"
                    required
                    v-on:keyup.enter="validate"
                    prepend-icon="person"
                    type="text"
                  />

                  <v-text-field
                    v-model="password"
                    label="Password"
                    type="password"
                    required
                    v-on:keyup.enter="validate"
                    prepend-icon="lock"
                  />
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn 
                    class="teal darken-4 white--text"
                    :disabled="!valid"
                    medium
                    @click="validate"
                >
                    Login
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>

        <v-snackbar style="z-index: 9999"
            :top='true'
            v-model='snackbar.visible'
            :color='snackbar.color'
            :timeout='snackbar.timeout'
            :multi-line='snackbar.multiline'
        >{{snackbar.text}}</v-snackbar>

        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import dayjs from "dayjs";
import moment from 'moment';
import firebase from "../firebaseConfig.js";
const db = firebase.database();

export default {
  data() {
    return {
      valid: true,
      password: "",
      email: "",
      overlay: false
    };
  },
  computed:{
    ...mapState({
      snackbar: state => state.snackbar,
      numberOfList: state => state.products.numberOfList,
    })
  },
  methods: {
    ...mapActions({
      logIn: "auth/logIn",
      getUsers: "auth/getUsers",
      cekJadwal: "jadwal/cekJadwal",
    }),
    ...mapMutations({
      showSnackbar: "showSnackbar"
    }),
    async validate() {
      if (this.$refs.form.validate()) {
        const payload = {
            email: this.email,
            password: this.password
        }
        try {
            this.overlay = true
            const response = await this.logIn(payload);
            if (!response.data.success) {
                this.showSnackbar({ text: response.data.message, color: 'red', timeout: 1500 })
            } else {
                await firebase.auth().signInAnonymously()
                const payload = {
                    from: dayjs().format('YYYY-MM-DD') + " 00:00:00",
                    to: dayjs().format('YYYY-MM-DD') + " 23:59:00"
                }
                const response = await this.cekJadwal(payload)
                const companyId = JSON.parse(window.localStorage.getItem('company')).id
                // console.log('response', response)
                // console.log('companyId', companyId)

                let now = moment().format('YYYY-MM-DD')
                let attendanceRefs = db.ref('Attendance-'+companyId+'-'+process.env.VUE_APP_ENV)
                attendanceRefs.child(now).once('value', (snap) => {
                  if(snap.val() == null){
                    db.ref("Attendance-"+companyId+'-'+process.env.VUE_APP_ENV)
                      .child(now).set(response.data.attributes)
                      .then(() => {
                        console.log("Document successfully written!");
                      })
                      .catch((error) => {
                        console.error("Error writing document: ", error);
                      });
                  }else{
                    response.data.attributes.forEach(jadwal => {
                      snap.val().forEach(fireValue => {
                        if(fireValue.id == jadwal.id){
                          if(fireValue.checkIn){
                            jadwal.checkIn = fireValue.checkIn
                          }
                        }
                      })
                    });
                    db.ref("Attendance-"+companyId+'-'+process.env.VUE_APP_ENV)
                      .child(now).set(response.data.attributes)
                      .then(() => {
                        console.log("Document successfully written!");
                      })
                      .catch((error) => {
                        console.error("Error writing document: ", error);
                      });
                  }
                });

                // window.localStorage.setItem('listJadwalToday', JSON.stringify(response.data.attributes));
                window.localStorage.setItem('listPesanan', JSON.stringify([]));
                window.localStorage.setItem('validatorOrder', true);
                window.localStorage.setItem('numberOfList', this.numberOfList);
                // if(window.localStorage.getItem('user_role') == 'stockiest'){
                //   this.$router.push("/orders");
                // }else{
                  this.$router.push("/dashboard");
                // }
            }
            this.overlay = false
        } catch (err) {
          console.log(err);
        }
      }
    },
  }
};
</script>